import { mediaSrc } from "@/components/ProductMediaUploader";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";
import { X, Minus, Plus, ShoppingBag } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, subtotal, update, remove, open, setOpen } = useCart();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-[#FAF8F5] w-full sm:max-w-md flex flex-col" data-testid="cart-drawer">
        <SheetHeader>
          <SheetTitle className="font-serif text-2xl text-[#1E3A2B] flex items-center gap-2">
            <ShoppingBag className="w-5 h-5" /> Your Wellness Cart
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto py-4 space-y-3">
          {items.length === 0 ? (
            <div className="text-center py-16 text-[#5A6B5D]">
              <ShoppingBag className="w-10 h-10 mx-auto mb-3 opacity-40" />
              <p className="text-sm">Your cart is empty. Explore verified Ayurvedic wellness.</p>
            </div>
          ) : (
            items.map((it) => (
              <div key={it.product_id} className="flex gap-3 bg-white border border-[#E2DDD5] rounded-xl p-3" data-testid={`cart-item-${it.product_id}`}>
                <img src={mediaSrc(it.image_url)} alt={it.name} className="w-16 h-16 rounded-lg object-cover" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-[#1A201C] line-clamp-2">{it.name}</div>
                  <div className="text-[11px] font-mono text-[#5A6B5D]">{it.vendor_name}</div>
                  <div className="mt-2 flex items-center justify-between">
                    <div className="flex items-center gap-2 border border-[#E2DDD5] rounded-full">
                      <button onClick={() => update(it.product_id, it.quantity - 1)} className="p-1.5" data-testid={`qty-dec-${it.product_id}`}><Minus className="w-3 h-3" /></button>
                      <span className="text-xs font-mono w-4 text-center">{it.quantity}</span>
                      <button onClick={() => update(it.product_id, it.quantity + 1)} className="p-1.5" data-testid={`qty-inc-${it.product_id}`}><Plus className="w-3 h-3" /></button>
                    </div>
                    <div className="text-sm font-bold text-[#1E3A2B]">{formatINR(it.price * it.quantity)}</div>
                  </div>
                </div>
                <button onClick={() => remove(it.product_id)} className="text-[#5A6B5D] self-start" data-testid={`remove-${it.product_id}`}><X className="w-4 h-4" /></button>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-[#E2DDD5] pt-4 space-y-3">
            <div className="flex items-center justify-between text-sm">
              <span className="text-[#5A6B5D]">Subtotal</span>
              <span className="font-bold text-[#1A201C] font-mono">{formatINR(subtotal)}</span>
            </div>
            <button
              onClick={() => { setOpen(false); nav("/checkout"); }}
              className="w-full btn-forest"
              data-testid="cart-checkout-button"
            >
              Proceed to Checkout
            </button>
            <p className="text-[10px] font-mono text-center text-[#5A6B5D]">Free shipping on orders above ₹1,500</p>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
